import { app } from '../../../../app';
import { Controller } from './integration-developers.controller';

app.component('companyManageApplicationIntegrationDevelopers', {
    bindings: {
        application: '<',
        companyId: '<',
    },
    controller: Controller,
    templateUrl: require('./integration-developers.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/integration-developers/integration-developers.component.js